import { useCallback } from 'react'
import { resolveCart } from '../../../cart/cartApi'
import { readCheckoutGuestCartId, writeCheckoutGuestCartId, writeStoredCartId } from '../../../cart/cartPersistence'

export const useGuestCartMerge = () =>
  useCallback(async (nextToken: string) => {
    const pendingGuestCartId = readCheckoutGuestCartId()
    if (!pendingGuestCartId) return

    try {
      const resolved = await resolveCart({
        cartId: pendingGuestCartId,
        token: nextToken,
      })
      writeStoredCartId(resolved.cartId)
    } catch {
      // Checkout flow will run a second resolve/merge attempt before session creation.
    } finally {
      writeCheckoutGuestCartId(null)
    }
  }, [])
